<template>
  <div class="login">
    <div class="login-l">
      <h1>四步入驻<br />让发货像<em>发消息</em>一样简单</h1>
      <p class="sub">
        证件拍照即录，信息自动回填；资料一次提交，审核通过当天即可发货。
      </p>
      <div class="feat">
        <div>
          <i>1</i>
          <div>
            <b>OCR 智能识别</b>
            <span>营业执照、身份证拍照即录，告别手工填写</span>
          </div>
        </div>
        <div>
          <i>2</i>
          <div>
            <b>1 日极速审核</b>
            <span>系统校验 + 人工复核，结果短信实时通知</span>
          </div>
        </div>
        <div>
          <i>3</i>
          <div>
            <b>专属客户经理</b>
            <span>入驻即配备一对一经理，全程协助</span>
          </div>
        </div>
      </div>
    </div>
    <div class="login-r">
      <!-- 在手机端显示，在PC端不显示；放在 login-r 内与登录区同左对齐 -->
      <div class="login-mobile-hd">
        <h1>四步入驻<br />让发货像<em>发消息</em>一样简单</h1>
      </div>
      <div class="login-card">
        <h2>欢迎入驻</h2>
        <p class="lead">
          请使用接收开通短信的手机号登录，凭验证码完成身份核验。
        </p>
        <div class="login-fields">
          <div class="fld">
            <label class="fld-lbl"><span class="req">*</span>手机号</label>
            <input
              v-model.trim="phone"
              class="fld-in mono"
              style="height:52px;font-size:16px"
              maxlength="11"
              placeholder="请输入业务负责人手机号"
            />
          </div>
          <div class="fld">
            <label class="fld-lbl"><span class="req">*</span>短信验证码</label>
            <div class="code">
              <input
                v-model.trim="verifyCode"
                class="fld-in mono"
                style="height:52px"
                maxlength="6"
                placeholder="6 位验证码"
              />
              <button
                type="button"
                class="btn"
                :disabled="smsCounting || smsLoading"
                @click="onSendSms"
              >
                {{
                  smsCounting
                    ? smsLeft + "s"
                    : smsSent
                    ? "重新获取"
                    : "获取验证码"
                }}
              </button>
            </div>
            <div v-if="smsSent" class="fld-hint">
              验证码已发送至 {{ maskPhone(phone) }}，5 分钟内有效
            </div>
          </div>
          <div class="agree">
            <input id="agree" v-model="agreed" type="checkbox" />
            <label for="agree" class="login_agreement_text_wrap">
              <span class="login_agreement_text">我已阅读并同意</span>
              <a
                href="javascript:;"
                class="login_link"
                @click.prevent.stop="goServices"
                >《用户服务协议》</a
              >
              <a
                href="javascript:;"
                class="login_link"
                @click.prevent.stop="goRule"
                >《平台交易规则》</a
              >
              <a
                href="javascript:;"
                class="login_link"
                @click.prevent.stop="goPrivale"
                >《隐私协议》</a
              >
            </label>
          </div>
          <button
            type="button"
            class="btn btn-pri btn-lg"
            style="width:100%"
            :disabled="loginLoading"
            @click="onLogin"
          >
            登 录
          </button>
          <div class="login-help">
            未收到短信？请联系市场人员或拨打 400-900-5666
          </div>
        </div>
      </div>
    </div>

    <vxe-modal
      v-model="verificationFlag"
      :show-header="false"
      title="验证码"
      :width="modalWidth"
      height="250"
      resize
      :transfer="true"
      :z-index="5000"
    >
      <verification ref="verificationRef" @receive="receive" @cancel="cancel" />
    </vxe-modal>
  </div>
</template>

<script>
import { GetRegisterVerifycode } from "@/api/user";
import { verifyInviteSms } from "@/api/shipperRegisterH5";
import verification from "@/views/register/components/verification";

export default {
  name: "LoginScreen",
  components: { verification },
  data() {
    return {
      phone: "",
      verifyCode: "",
      agreed: false,
      smsSent: false,
      smsCounting: false,
      smsLeft: 60,
      smsTimer: null,
      smsLoading: false,
      loginLoading: false,
      verificationFlag: false,
      modalWidth: 450
    };
  },
  created() {
    this.updateModalWidth();
    window.addEventListener("resize", this.updateModalWidth);
  },
  beforeDestroy() {
    if (this.smsTimer) clearInterval(this.smsTimer);
    window.removeEventListener("resize", this.updateModalWidth);
  },
  methods: {
    updateModalWidth() {
      this.modalWidth = window.innerWidth < 640 ? "92%" : 450;
    },
    maskPhone(p) {
      if (!p || p.length < 7) return p || "";
      return p.slice(0, 3) + "****" + p.slice(-4);
    },
    goPrivale() {
      window.open(
        "https://lianbb56.com/agreement/agreement.html?agreementType=7"
      );
    },
    goRule() {
      window.open(
        "https://lianbb56.com/agreement/agreement.html?agreementType=5"
      );
    },
    goServices() {
      window.open(
        "https://lianbb56.com/agreement/agreement.html?agreementType=8"
      );
    },
    validPhone() {
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$message.warning("请输入正确的手机号");
        return false;
      }
      return true;
    },
    onSendSms() {
      if (this.smsCounting) return;
      if (!this.validPhone()) return;
      const baseUrl = this.BASE_API_URL || "";
      const imgurl =
        `${baseUrl}ntocc-tps-api/sms/getVerificationCodeImage?phone=` +
        this.phone +
        "&imageWith=300&imageHeigth=100&t=" +
        new Date().getTime();
      this.verificationFlag = true;
      this.$nextTick(() => {
        const ref = this.$refs.verificationRef;
        if (ref && typeof ref.getVerificationCodeImage === "function") {
          ref.getVerificationCodeImage(imgurl);
        }
      });
    },
    cancel() {
      this.verificationFlag = false;
    },
    async receive(imageCode) {
      this.verificationFlag = false;
      if (!imageCode) {
        this.$message.error("请输入验证码");
        return;
      }
      this.smsLoading = true;
      try {
        const res = await GetRegisterVerifycode({
          phone: this.phone,
          partyGroupCode:
            this.$route.query.branchCode || "67a375220847460c14qingdaominlian",
          imageCode
        });
        if (res && String(res.status) === "0") {
          this.smsSent = true;
          this.startCountdown();
          this.$message.success("验证码已发送");
        } else {
          this.$message.error((res && res.msg) || "验证码发送失败");
        }
      } catch (e) {
        this.$message.error((e && e.message) || "发送失败");
      } finally {
        this.smsLoading = false;
      }
    },
    startCountdown() {
      if (this.smsTimer) clearInterval(this.smsTimer);
      this.smsCounting = true;
      this.smsLeft = 60;
      this.smsTimer = setInterval(() => {
        this.smsLeft -= 1;
        if (this.smsLeft < 0) {
          clearInterval(this.smsTimer);
          this.smsTimer = null;
          this.smsCounting = false;
        }
      }, 1000);
    },
    async onLogin() {
      if (!this.validPhone()) return;
      if (!this.verifyCode) {
        this.$message.warning("请输入验证码");
        return;
      }
      if (!this.agreed) {
        this.$message.warning("请先阅读并同意相关协议");
        return;
      }
      const inviteId =
        this.$route.query.inviteId || this.$route.query.inviteCode || "";
      const token = this.$route.query.token || "";
      if (!inviteId || !token) {
        this.$message.warning("邀请链接无效，请重新获取邀请链接");
        return;
      }
      this.loginLoading = true;
      try {
        const res = await verifyInviteSms({
          phone: this.phone,
          verifyCode: this.verifyCode,
          inviteId,
          token
        });
        if (res && String(res.status) === "0") {
          // 仅保存手机号与申请 code，不写 Admin-Token
          const code = (res.data && res.data.code) || "";
          sessionStorage.setItem("shipperRegisterH5Phone", this.phone);
          sessionStorage.setItem("shipperRegisterH5Code", code);
                    this.$emit("success", { phone: this.phone, code });
        } else {
          this.$message.error((res && res.msg) || "验证失败");
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loginLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-mobile-hd {
  display: none;
}
.login-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.login-fields .fld {
  margin-bottom: 0;
}
.login-help {
  text-align: center;
  font-size: 12.5px;
  color: var(--ink4);
}
@media (max-width: 900px) {
  .login-r {
    flex-direction: column;
    align-items: stretch;
  }
  .login-mobile-hd {
    display: block;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    padding: 0 0 var(--s4);
    box-sizing: border-box;
    height: 100px;
  }
  .login-mobile-hd h1 {
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.3px;
    margin: 0;
    color: var(--ink);
    /* 与 login-card 内边距对齐，和输入区左侧一致 */
    padding: 0 var(--s6);
  }
  .login-mobile-hd em {
    font-style: normal;
    background: linear-gradient(90deg, #5b7cfa, #8b5cf6);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
}
@media (max-width: 640px) {
  .login-mobile-hd h1 {
    padding: 0 var(--s4);
  }
  .login-fields {
    gap: 16px;
  }
}
</style>
